import { GlLoadingIcon } from '@gitlab/ui';
import {
  SECURITY_SCAN_ROUTE,
  LICENSE_COMPLIANCE_ROUTE,
  CODE_QUALITY_ROUTE,
  LOAD_PERFORMANCE_ROUTE,
  ROOT_ROUTE,
  METRICS_ROUTE,
} from './constants';

const CATCH_ALL_ROUTE = '/:pathMatch(.*)*';

export default [
  {
    name: ROOT_ROUTE,
    path: '/',
    component: {
      render(h) {
        return h(GlLoadingIcon, { props: { size: 'lg' } });
      },
    },
  },
  {
    name: SECURITY_SCAN_ROUTE,
    path: `/${SECURITY_SCAN_ROUTE}`,
    component: () =>
      import('ee_component/merge_requests/reports/security_scans/security_scans_page.vue'),
  },
  {
    name: LICENSE_COMPLIANCE_ROUTE,
    path: `/${LICENSE_COMPLIANCE_ROUTE}`,
    component: () =>
      import('ee_component/merge_requests/reports/license_compliance/license_compliance_page.vue'),
  },
  {
    name: CODE_QUALITY_ROUTE,
    path: `/${CODE_QUALITY_ROUTE}`,
    component: () => import('~/merge_requests/reports/code_quality/code_quality_page.vue'),
  },
  {
    name: LOAD_PERFORMANCE_ROUTE,
    path: `/${LOAD_PERFORMANCE_ROUTE}`,
    component: () =>
      import('ee_component/merge_requests/reports/load_performance/load_performance_page.vue'),
  },
  {
    name: METRICS_ROUTE,
    path: `/${METRICS_ROUTE}`,
    component: () => import('ee_component/merge_requests/reports/metrics/metrics_page.vue'),
  },
  {
    path: CATCH_ALL_ROUTE,
    component: { render: () => null },
    beforeEnter(to, from, next) {
      // The MR page has two navigation systems: MR Tabs (merge_request_tabs.js)
      // and Vue Router. Both listen to the browser's Back button. When the user
      // presses Back to leave the Reports tab, Vue Router sees a URL it doesn't
      // recognize, which causes unexpected navigation behaviour. This catch-all
      // cancels the navigation and lets MR Tabs handle it.
      const currentUrl = window.location.href;
      next(false);
      window.history.replaceState(null, null, currentUrl);
    },
  },
];
